import React, { useCallback } from 'react';

import Routes from '../Routes';
import { AppContext } from 'App';
import { Notification } from 'featureLib/NotificationComponent';
// import ToastComponent from 'common/components/toast/toast.component';
import StepsHeader from 'home/components/functional/steps-header/steps.component';
import { OvRejectionNotification } from 'featureLib/NotificationComponent';
import { findParamFromUrl, getFromSessionStorage, getNotificationType, isSingleUpgradeOrShiftingJourney, isSiteReadinessPage } from 'common/utils/app.utils';
import { MULTIPLE_SITE, SINGLE_SITE } from 'home/view/manage-feasibility/constants';
import { isLandingPage } from 'common/utils/app.utils';
import { MODULE_ID } from 'home/common/constants/constants';
import { JOURNEY_TYPE, STORAGE_KEY } from 'common/constants/app.constants';

const InnerLayout = (props) => {
  const {
    activeStep,
    multiSiteFileUploadSuccess,
    selectedRadio,
    setActiveStep,
    setSelectedRadio,
    setToast,
    toast,
    showSteps,
    setMultiSiteFileUploadSuccess,
    setNotification,
    notificationState,
    toastState,
    closeNetworkCoveragePopup,
    steps,
    isdedicatedJourney,
    partyIdFromUrl,
    setIsAuthJourney,
    isUnAuthJourney,
    lob,
    toggelNotification,
    pageData,
    featureToggler
  } = props;

  const isMultiSite = selectedRadio?.id === MULTIPLE_SITE;
  const userSelectedSingleUpgrade = getFromSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE) === JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING;
  const isSingleSiteUpgrade = isSingleUpgradeOrShiftingJourney() || userSelectedSingleUpgrade;

  const renderNotifications = () => {
    if (isMultiSite || (isLandingPage() && isSingleSiteUpgrade)) {
      return (
        <section id="notification" className="notification">
          <Notification
            show={toastState.show}
            type={getNotificationType(toastState.type)}
            message={toastState.message}
            eventHandler={toastState.eventHandler || closeNetworkCoveragePopup}
            onCancel={closeNetworkCoveragePopup}
          ></Notification>
        </section>
      );
    }
  };

  const renderAuthStepper = useCallback(() => {
    if (((isMultiSite && !isSiteReadinessPage()) || (isLandingPage() && isSingleSiteUpgrade)) && steps && !isUnAuthJourney) {
      return (
        <StepsHeader
          hideBackBtn={true}
          activeStepIndex={activeStep}
          isdedicatedJourney={isdedicatedJourney}
          isUnAuthJourney={false}
          skipNetworkstatus={true}
          isMultiSite={true}
          showTrackBtn={true}
        />
      );
    }

    return null;
  }, [isMultiSite, steps, activeStep]);

  return (
    <React.Fragment>
      <AppContext.Provider
        value={{
          activeStep,
          multiSiteFileUploadSuccess,
          selectedRadio,
          setActiveStep,
          setSelectedRadio,
          setToast,
          toast,
          showSteps,
          setMultiSiteFileUploadSuccess,
          setNotification,
          setIsAuthJourney,
          pageData,
          featureToggler
        }}
      >
        <section id="notification" className="notification">
          <Notification
            show={notificationState.show}
            type={notificationState.type}
            message={notificationState.message}
            eventHandler={notificationState.eventHandler}
            onCancel={notificationState.onCancel}
          ></Notification>
        </section>

        <section className="stepper">
          {/* <section id="toast">
            {!isBulkUpgrade() && toastState.show && (
              <ToastComponent
                topPosition={150}
                closeNetworkCoveragePopup={closeNetworkCoveragePopup}
                toastMessage={toastState.message}
                successToast={toastState.type}
                closeToastTime={'8000'}
              />
            )}
          </section> */}
          {renderAuthStepper()}
        </section>

        {renderNotifications()}

        <section id="notification-ov-rejection" className="notification_panel">
          <OvRejectionNotification
            show={notificationState.showOvRejection}
            type={notificationState.type}
            message={notificationState.message}
            eventHandler={notificationState.eventHandler}
          ></OvRejectionNotification>
        </section>

        <Routes toggelNotification={toggelNotification} isUnAuthJourney={isUnAuthJourney} isdedicatedJourney={isdedicatedJourney}></Routes>
      </AppContext.Provider>
    </React.Fragment>
  );
};

export default InnerLayout;
